import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Superscript } from "@components"
import AwardBadge from "./award-badge"
import style from "./people-grid-card.mod.scss"

const PeopleGridCard = ({
  heading,
  subHeading,
  awardLabel = "",
  caption,
  image,
  showAwardBadge = false
}) => {
  return (
    <div className={style.peopleCard}>
      {image && (
        <div className={style.peopleCard__image}>
          <GatsbyImage
            image={image.gatsbyImageData}
            loading="lazy"
            alt={image.alt || ""}
          />
          {showAwardBadge && (
            <AwardBadge
              className={style.peopleCard__awardBadge}
              aria-hidden="true"
              focusable="false"
            />
          )}
        </div>
      )}
      <div className={style.peopleCard__content}>
        {heading && (
          <h3
            className={style.peopleCard__heading}
            children={<Superscript children={heading} />}
          />
        )}
        {subHeading && (
          <p
            className={style.peopleCard__subHeading}
            children={<Superscript children={subHeading} />}
          />
        )}
        {awardLabel && (
          <p
            className={style.peopleCard__award}
            children={<Superscript children={awardLabel} />}
          />
        )}
        {caption && (
          <div
            className={style.peopleCard__lead}
            children={<Superscript children={caption} />}
          />
        )}
      </div>
    </div>
  )
}

export default PeopleGridCard
